import _ from 'lodash'
import { deleteEntries, deleteEntry } from 'shared-js/utils/array-utils'

export function cleanOfferItemGroups (offer, menuBlob) {
  _.forEachRight(offer.itemGroups, itemGroup => {
    _.forEachRight(itemGroup.choices, choice => cleanOfferChoice(choice, itemGroup, menuBlob))

    if (itemGroup.choices.length === 0) {
      deleteEntry(offer.itemGroups, it => it.id === itemGroup.id)
    }
  })
}

function cleanOfferChoice (choice, itemGroup, menuBlob) {
  const doRemove = () => itemGroup.choices.splice(itemGroup.choices.indexOf(choice), 1)

  const department = _.get(menuBlob, 'departments', []).find(it => it.id === choice.departmentId)

  if (!department) {
    return doRemove()
  }

  if (['CATEGORY', 'ITEMS'].includes(choice.level) &&
    !_.get(department, 'categories', []).find(it => it.id === choice.categoryId)) {
    return doRemove()
  }

  if (choice.level === 'ITEM' && !_.get(department, 'items', []).find(it => it.id === choice.itemId)) {
    return doRemove()
  }

  const styles = _.get(department, 'styles', [])

  const availableStyleOptions = _.get(styles.find(it => !it.isSize), 'options', []).map(it => it.id)
  const availableSizeOptions = _.get(styles.find(it => it.isSize), 'options', []).map(it => it.id)

  deleteEntries(choice.limitToSizeIds, it => !availableSizeOptions.includes(it))
  deleteEntries(choice.limitToStyleIds, it => !availableStyleOptions.includes(it))
}
